import React from 'react';
import PrivacyPolicy from '../PricvacyPolicy';

const DailyFlowPrivacyPolicy = () => {

  console.log("DailyFlow component rendering");
    const appSpecificContent = {
      en: {
        developer: "Developer: 물가의새",
        title: "DailyFlow Privacy Policy",
        lastUpdated: "Last Updated: April 2, 2025",
        collectInfo: "1. Information We Collect",
        collectDescription:
          "In DailyFlow, we collect the following information to provide our scheduling and productivity services:",
        collectList: [
          "Schedule data including event titles, descriptions, dates, and times",
          "User preferences for notifications and reminders",
          "App usage patterns to improve user experience",
          "Device information for optimization purposes"
        ],
        usagePurpose: "2. Purpose of Information Use",
        usageDescription: "Your information helps us to:",
        usageList: [
          "Provide personalized scheduling recommendations",
          "Improve productivity features based on usage patterns",
          "Deliver relevant notifications and reminders",
          "Enhance overall service quality through anonymous data analysis"
        ],
        dataSharing: "3. Data Sharing & Third-Party Disclosure",
        sharingDescription:
          "DailyFlow does not share personal schedule data with third parties. Anonymous, aggregated usage statistics may be shared with analytics partners to improve our services.",
        dataStorage: "4. Data Retention & Deletion",
        storageDescription:
          "Your schedule data is stored securely for as long as you maintain an active account. You can export or delete your data at any time through the app settings.",
        contact: "5. Contact",
        contactDescription: "For any privacy-related inquiries about DailyFlow, please contact dailyflow1011@gmail.com",
        changeLang: "Change to Korean",
      },
      ko: {
        developer: "개발자: 물가의새",
        title: "데일리플로우 개인정보처리방침",
        lastUpdated: "최종 업데이트 날짜: 2025년 4월 2일",
        collectInfo: "1. 수집하는 정보",
        collectDescription:
          "데일리플로우에서는 일정 관리 및 생산성 서비스를 제공하기 위해 다음 정보를 수집합니다:",
        collectList: [
          "일정 제목, 설명, 날짜 및 시간을 포함한 일정 데이터",
          "알림 및 리마인더에 대한 사용자 환경설정",
          "사용자 경험 개선을 위한 앱 사용 패턴",
          "최적화를 위한 기기 정보"
        ],
        usagePurpose: "2. 정보 이용 목적",
        usageDescription: "수집된 정보는 다음과 같이 활용됩니다:",
        usageList: [
          "개인화된 일정 추천 제공",
          "사용 패턴 기반 생산성 기능 개선",
          "관련 알림 및 리마인더 전달",
          "익명 데이터 분석을 통한 전반적인 서비스 품질 향상"
        ],
        dataSharing: "3. 정보 공유 및 제3자 제공",
        sharingDescription:
          "데일리플로우는 개인 일정 데이터를 제3자와 공유하지 않습니다. 서비스 개선을 위해 익명화되고 집계된 사용 통계가 분석 파트너와 공유될 수 있습니다.",
        dataStorage: "4. 데이터 보관 및 삭제",
        storageDescription:
          "귀하의 일정 데이터는 계정이 활성화되어 있는 동안 안전하게 저장됩니다. 앱 설정을 통해 언제든지 데이터를 내보내거나 삭제할 수 있습니다.",
        contact: "5. 연락처",
        contactDescription: "데일리플로우 관련 개인정보 문의는 dailyflow1011@gmail.com으로 연락주세요.",
        changeLang: "영어로 변경",
      },
    };
    console.log("Passing content to base component:", appSpecificContent);
    
    // Using the original PrivacyPolicy component but with custom content
    return <PrivacyPolicy customContent={appSpecificContent} />;
  };

  export default DailyFlowPrivacyPolicy;